import { Box, Paper, Typography } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React from "react";
import { i18n } from "../../translate/i18n";
import ContactImport from "../../components/ContactImport";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";

const useStyles = makeStyles(theme => {
    const ds = theme.chatiaDS || {};
    const dsColors = ds.colors || {};
    const isDark = theme.palette.type === "dark" || theme.mode === "dark";
    return {
        mainPaper: {
            flex: 1,
            padding: 0,
            minHeight: 0,
            overflow: "hidden",
            borderRadius: 0,
            background: "transparent",
            border: "none",
            boxShadow: "none",
            display: "flex",
            flexDirection: "column",
        },
    };
});

const ContactImportPage = () => {
    const classes = useStyles();
    const theme = useTheme();
    const isDark = theme.palette.type === "dark" || theme.mode === "dark";

    return (
        <MainContainer>
            <MainHeader>
                <Box>
                    <Typography
                        component="h1"
                        style={{
                            fontSize: 28,
                            fontWeight: 800,
                            letterSpacing: -0.6,
                            lineHeight: 1.15,
                            color: isDark ? "#e9edef" : "#0f172a",
                        }}
                    >
                        {i18n.t("contactImport.title")}
                    </Typography>
                    <Typography style={{ marginTop: 2, fontSize: 13, color: isDark ? "#8696a0" : "#64748b" }}>
                        {i18n.t("contactImport.subtitle") || "Envie um arquivo XLS, XLSX, CSV ou TXT"}
                    </Typography>
                </Box>
            </MainHeader>
            <Paper className={classes.mainPaper} variant="outlined">
                <ContactImport />
            </Paper>
        </MainContainer>
    );
};

export default ContactImportPage;
